function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const NotifyIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 16a4 4 0 1 1 8 0 4 4 0 0 1-8 0zm8.761-8.796C23.881 8.896 26 12.201 26 16s-2.119 7.104-5.239 8.796C22.138 22.605 23 19.475 23 16s-.862-6.605-2.239-8.796zM9 16c0 3.475.862 6.605 2.239 8.796C8.119 23.104 6 19.799 6 16s2.119-7.104 5.239-8.796C9.862 9.395 9 12.525 9 16zm-6 0c0 5.372 1.7 10.193 4.395 13.491C2.948 26.649 0 21.669 0 16S2.948 5.351 7.395 2.509C4.7 5.807 3 10.628 3 16zM24.605 2.509C29.052 5.351 32 10.331 32 16s-2.948 10.649-7.395 13.491C27.3 26.193 29 21.372 29 16S27.3 5.807 24.605 2.509z"
  }));
};
export default NotifyIcon;